var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M17.7,2a.9.9,0,0,0-.729.429l-3.9,6a.986.986,0,0,0,0,.857.814.814,0,0,0,.729.429h7.757a.9.9,0,0,0,.729-.429.771.771,0,0,0,0-.857l-3.857-6A.814.814,0,0,0,17.7,2Z",
    transform: "translate(-5.698 0)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M33.857,32.714h-6A.857.857,0,0,1,27,31.857v-6A.857.857,0,0,1,27.857,25h6a.857.857,0,0,1,.857.857v6A.857.857,0,0,1,33.857,32.714Z",
    transform: "translate(-13.714 -13.143)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M7.286,24a4.286,4.286,0,1,0,4.286,4.286A4.286,4.286,0,0,0,7.286,24Z",
    transform: "translate(0 -12.572)",
    fill: "#5a5a5a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategories);
export default __webpack_public_path__ + "static/media/categories.d6dfd45dbef43844385d2e8647a59a00.svg";
export { ForwardRef as ReactComponent };